// English strings (source language): Online screen (rooms, chat).

const en = {
  intro: 'Race with your friends, each on their own smart trainer.',
  connecting: 'Connecting…',
  unreachable: 'Unable to connect right now',
  unreachableHelp: 'Check your connection and try again.',
  retry: 'Try again',
  // Supporters (spectator mode)
  watching: 'Watching a room',
  youWatch: 'you are a supporter',
  supporters: (n: number) => `${n} supporter${n === 1 ? '' : 's'}`,
  supportersTitle: 'Supporters',
  noSupporters: 'Nobody is watching yet. Share the spectator link.',
  watchLink: 'Spectator link',
  audience: 'Supporters',
  audienceChat: 'Supporters can chat',
  audienceBoost: 'Cheers give a crowd boost (+3 % for 3 s, once per 20 s per rider)',
  audienceEventNote: 'In an event stage, cheers are heard only: no crowd boost.',
  raceUnderway: 'The race has started: you join it where it has got to.',
  waitingStart: 'The race has not started yet: you will join the broadcast when the host starts it.',
  joinAsPlayer: 'Join as a player',
  spectatorBadge: 'supporter',
  mute: 'Mute',
  unmute: 'Unmute',
  muted: 'muted',
  mutedTip: 'Muted by the host: no chat, no cheers',
  removeSupporter: 'Remove from the room',
  room: 'Room',
  players: (n: number) => `${n} player${n === 1 ? '' : 's'}`,
  seats: (max: number) => `${max} seats`,
  youHost: 'you are the host',
  waitingHost: 'waiting for the host',
  leave: 'Leave room',
  roomCode: 'ROOM CODE',
  invite: 'Invite link',
  copy: 'Copy',
  localLink: 'Local link: for friends outside your network, start the host with the public tunnel.',
  changeRace: 'Change mode or track',
  changeDone: 'Done',
  race: 'Race',
  groupWorkout: 'Group workout',
  workout: 'Workout',
  groupWorkoutHelp: 'Everyone rides the same workout at the same time, on the same clock. Each rider’s targets come from their own FTP. No bots.',
  botsHelp: 'Bots are calibrated on the players’ average W/kg. A race seats up to 50 riders, players and bots together; from 13 riders the start is rolling.',
  readyCancel: 'Ready (cancel)',
  imReady: 'I’m ready',
  start: 'Start the race',
  readyCount: (n: number, total: number) => `${n}/${total} ready`,
  hostWillStart: 'The host will start the race.',
  playersTitle: 'Players',
  verified: 'Verified account',
  you: '(you)',
  ready: 'Ready',
  chat: 'Chat',
  messagePlaceholder: 'Message…',
  send: 'Send',
  linkCopied: 'Link copied',
};
export default en;
